import React from 'react';
import {Link, Route, Redirect, withRouter} from 'react-router-dom';
import {Table, Tag, Button, Spin, Row, Col, Breadcrumb, Divider, Input, Icon} from 'antd';
import Highlighter from 'react-highlight-words';

import userService from '../services/users.service';
import Toolbar from '../commons/Toolbar';
import './UsersCss.css';

const filterColumns = {
    onChange: (pagination, filters, sorter) => {
        console.log('params', pagination, filters, sorter);
    }
};
const {Search} = Input;

class UsersContainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            dataTable: [],
            pagination: {},
            loading: true,
            toUserDetail: false,
            toUserEdit: false,
            selectedUserKey: '',
            selectedUser: [],
            searchText: '',

        };

    }


    componentDidMount = () => {
        userService.getUsers().then((data) => {
            console.log('User data: ', data);
            /******************************************/
            /* Add a property called 'name' which is firstname + lastname to the data to do sorting by Name*/
            let name = {};
            let responza = {};
            let newData = [];
            for (let i of data) {
                name = {"name": i.firstName + ' ' + i.lastName};
                responza = {...i, ...name};
                newData.push(responza);
            }
            /**************************************/
            this.setState(() => {
                return {dataTable: newData, loading: false}
            })
        });
    };


    /********************************/
    /* Search button on each column: name, username, and email*/
    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => (
            <div style={{padding: 8}}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
                    style={{width: 188, marginBottom: 8, display: 'block'}}
                />
                <Button
                    type="primary"
                    onClick={() => this.handleSearch(selectedKeys, confirm)}
                    icon="search"
                    size="small"
                    style={{width: 90, marginRight: 8}}
                >
                    Search
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{width: 90}}>
                    Reset
                </Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type="search" style={{color: filtered ? '#1890ff' : undefined}}/>
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select());
            }
        },
        render: text => (
            <Highlighter
                highlightStyle={{backgroundColor: '#ffc069', padding: 0}}
                searchWords={[this.state.searchText]}
                autoEscape
                textToHighlight={text.toString()}
            />
        ),
    });

    handleSearch = (selectedKeys, confirm) => {
        confirm();
        this.setState({searchText: selectedKeys[0]});
    };

    handleReset = clearFilters => {
        clearFilters();
        this.setState({searchText: ''});
    };

    /*****************************************************************/


    render() {

        const columns = [
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
                sorter: (a, b) => {
                    return a.name.localeCompare(b.name, 'en', {
                        caseFirst: false,
                        sensitivity: 'base',
                        numeric: true,
                        ignorePunctuation: true
                    })
                },
                ...this.getColumnSearchProps('name'),
            },
            {
                title: 'User Name',
                dataIndex: 'username',
                key: 'username',
                ...this.getColumnSearchProps('username'),
            },

            {
                title: 'E-mail',
                dataIndex: 'email',
                key: 'email',
                ...this.getColumnSearchProps('email'),
            },
            {
                title: 'Role',
                key: 'role',
                filters: [
                    {
                        text: 'Administrator',
                        value: 'Administrator',
                    },
                    {
                        text: 'Supervisor',
                        value: 'Supervisor',
                    },
                    {
                        text: 'Data Entry',
                        value: 'Data Entry',
                    },
                ],
                onFilter: (value, record) => record.role.indexOf(value) === 0,
                dataIndex: 'role',
                render: (role) => {

                    let color = 'green';

                    if (role === 'Administrator') {
                        color = 'volcano';
                    }

                    if (role === 'Supervisor') {
                        color = 'geekblue';
                    }

                    return (<span>  {role.toUpperCase()} </span>)
                },
            },
            {
                title: 'Purview',
                dataIndex: 'purview',
                key: 'purview',
                sorter: (a, b) => {
                    return a.purview.localeCompare(b.purview, {sensitivity: 'base'})
                },

            },
            {
                title: 'Status',
                key: 'status',
                filters: [
                    {
                        text: 'Active',
                        value: 'Active',
                    },
                    {
                        text: 'Inactive',
                        value: 'Inactive',
                    },
                ],
                onFilter: (value, record) => record.status.indexOf(value) === 0,
                dataIndex: 'status',
                render: (status) => {
                    let color = 'green';

                    if (status === 'Inactive') {
                        color = 'volcano';
                    }
                    return (
                        <Tag color={color} key={status}>
                            {status.toUpperCase()}
                        </Tag>
                    )

                },
            },
        ];


        const pagination = {
            total: this.state.count,
            pageSize: 12,
            pageSizeOptions: ['50'],
        }

        if (this.state.toUserDetail === true) {
            return <Redirect to='/users/detail'/>
        }
        else {

            const hasSelected = this.state.selectedUser.length > 0;

            if (hasSelected) {
                console.log('this.state.selectedUser[0]: ', this.state.selectedUser[0]._id);
                console.log('hasSelected: ', hasSelected);

            }

        const toolBarItems = [
                {
                    title: 'add',
                    icon: 'plus',
                    onClick: () => this.setState(state => ({
                        toUserDetail: !state.toUserDetail,
                    }))
                },
                {
                    title: 'edit',
                    icon: 'edit',
                    disabled: !hasSelected,
                    onClick:()=>this.props.history.push({
                        pathname: '/users/edit',
                        state: this.state.selectedUser})
                },
        ]

            return (
                <div>
                    <Row>
                        <Breadcrumb style={{margin: '16px 0'}}>
                            <Breadcrumb.Item>Users</Breadcrumb.Item>
                        </Breadcrumb>
                        <Divider style={{background: '#8080802e', margin: '0px 0px 17px 0px'}}/>
                    </Row>
                    <Row>
                        <Col span={12}>
                            <Row type="flex" justify="start">
                                <Search
                                    onSearch={value => {
                                        this.setState(
                                            {
                                                searchString: value,
                                            },
                                        )
                                    }}
                                    style={{width: 330}}/>

                            </Row>
                        </Col>
                        <Col span={12}>
                            <Row type="flex" justify="end">
                                <Toolbar items={toolBarItems}/>
                            </Row>
                        </Col>
                        <Divider style={{background: 'transparent', margin: '5px 0px 12px 0px'}}/>
                    </Row>
                    <Row>
                        <Col span={24}>
                            <Spin spinning={this.state.loading} delay={500}>
                                <div className="tableContainer">
                                <Table
                                    className={"userTable"}
                                    columns={columns}
                                    dataSource={this.state.dataTable}
                                    onRow={(record, rowIndex) => ({
                                        onClick: () => {
                                            console.log('Record: ', record);
                                            console.log('rowIndex: ', rowIndex);
                                            this.setState({
                                                selectedUserKey: [rowIndex],
                                                selectedUser: [record],
                                            })
                                        },
                                    })}
                                    rowClassName={(record, index) =>
                                        this.state.selectedUserKey &&
                                        this.state.selectedUser
                                            ? index === this.state.selectedUserKey[0] &&
                                            record === this.state.selectedUser[0]
                                            ? 'highlight'
                                            : ''
                                            : null
                                    }
                                    onChange={(pagination, filters, sorter) => {
                                        console.log('Pagination: ', pagination);
                                        console.log('Filters: ', filters);
                                        console.log('Sorter: ', sorter);
                                    }}
                                    filter={filterColumns}
                                    pagination={pagination}
                                />
                                </div>
                            </Spin>
                        </Col>
                    </Row>
                </div>
            )
        }

    }
}

export default withRouter(UsersContainer)